export const AUTH_SESSION_KEY = 'piu_portal_session';

export const STORAGE_KEYS = {
  dataVersion: 'tvet_data_version',
  civil: 'tvet_civil_v1',
  civilFinancial: 'tvet_civil_financial_v1',
  coeOperational: 'tvet_coe_operational_v1',
  training: (c: number) => `tvet_training_c${c}_v1`,
  c1Placement: 'tvet_c1_placement_v1',
  c2Placement: 'tvet_c2_placement_v1',
  trainingLegacy: 'tvet_training_v1',
  component3: 'tvet_component3_cs06_v1',
  contractMgmt: 'tvet_cm_v1',
  procYetToInitiate: 'tvet_proc_yti_v1',
  procInprocess: 'tvet_proc_inprocess_v1',
  procOngoing: 'tvet_proc_ongoing_v1',
  procCompleted: 'tvet_proc_completed_v1',
  procCivil: 'tvet_proc_civil_v1',
  procHistory: 'tvet_proc_history_v1',
  gap: 'tvet_gap_v1',
  gapAlert: 'tvet_gap_alert_v1',
  budget: 'tvet_budget_v1',
  accounts: 'tvet_accounts_v1',
  audit: 'tvet_audit',
} as const;
